import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const ProgressBar = (props) => {
    const { classObject, max, current, threshold, height, color, overThresholdColors, trackColor, blurEffect = false, } = props;
    const borderRadius = 10;
    const thresholdPosition = (threshold / max) * 100;
    let progressPosition = (current / max) * 100;
    let currentIsOverThreshold = false;
    if (threshold && progressPosition > thresholdPosition) {
        progressPosition = thresholdPosition;
        currentIsOverThreshold = true;
    }
    const styles = StyleSheet.create({
        background: {
            filter: blurEffect ? 'blur(3px)' : null,
            width: '100%',
            height: height || 4,
            borderRadius: borderRadius,
            backgroundColor: trackColor !== null && trackColor !== void 0 ? trackColor : Colors.White,
            position: 'relative',
            overflow: 'hidden',
        },
        progress: {
            background: color !== null && color !== void 0 ? color : Colors.GradationPrimary,
            position: 'absolute',
            borderRadius: currentIsOverThreshold ? `${borderRadius}px 0 0 ${borderRadius}px` : borderRadius,
            top: 0,
            bottom: 0,
            width: `${progressPosition}%`,
            transition: 'width .2s',
        },
        threshold: {
            background: Colors.White,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: `${thresholdPosition}%`,
            width: 3,
        },
        progressOverThreshold: {
            background: overThresholdColors !== null && overThresholdColors !== void 0 ? overThresholdColors : Colors.Orange,
            width: `${(current / max) * 100}%`,
            borderRadius: borderRadius,
        },
    });
    return (React.createElement("div", { className: css(styles.background, classObject) },
        threshold && React.createElement("div", { className: css(styles.progress, styles.progressOverThreshold) }),
        React.createElement("div", { className: css(styles.progress) }),
        threshold && React.createElement("div", { className: css(styles.threshold) })));
};
